var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel panel-default panel-dashboard"},[_c('div',{staticClass:"panel-body"},[_c('canvas',{attrs:{"width":"800","height":"250"}})])])
}]

export { render, staticRenderFns }